import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { User } from 'app/models/user';
import { Client } from '../models/client';
import { environment } from '../../environments/environment';
import { HttpClient } from "@angular/common/http";
import { map } from 'rxjs/operators';

@Injectable()
export class UserService {

  constructor(private http: HttpClient) {
  }

  get(): Observable<User[]> {
    return this.http.get<any>(`${environment.apiUrl}/users`)
      .pipe(map(json => {
        return json.data.map(row => {
          return new User(row);
        });
      }));
  }

  getForClient(client: Client): Observable<User[]> {
    return this.http.get<any>(`${client.url}/users`)
      .pipe(map(json => {
        return json.data.map(row => {
          return new User(row);
        });
      }));
  }

  create(data: { name: string, email: string, client: number, send_password: boolean }): Observable<User> {
    let body = JSON.stringify(data);
    return this.http.post<any>(`${environment.apiUrl}/users`, body)
      .pipe(map(json => {
        return new User(json);
      }));
  }


  update(user: User, data: { name: string, email: string, client: number }): Observable<User> {
    let body = JSON.stringify(data);
    return this.http.put<any>(`${user.url}`, body)
      .pipe(map(json => {
        return new User(json);
      }));
  }

  destroy(user: User): Observable<void> {
    return this.http.delete<any>(`${user.url}`)
      .pipe(map(response => {
        return;
      }));
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/user.service.ts